import type {ReactLocalization} from "@fluent/react";

import type StudyTarget from "./StudyTarget";

function describeStudyTarget(
	l10n: ReactLocalization,
	numberOfExerciseTypes: number,
	target: StudyTarget
) {
	let types;

	if (
		!target.exerciseTypes ||
		target.exerciseTypes.length === 0 ||
		target.exerciseTypes.length === numberOfExerciseTypes
	) {
		types = l10n.getString("study-target-exercise-type-name", {
			type: "all",
		});
	} else {
		types = target.exerciseTypes
			.map((t) =>
				l10n.getString("study-target-exercise-type-name", {
					type: t,
				})
			)
			.join(", ");
	}

	return l10n.getString("study-target-description", {
		types: types,
		threshold: target.threshold,
		parameter: target.parameter,
		weighted: target.weighted ? 1 : 0,
	});
}

export default describeStudyTarget;
